import { colorsPalettes, mixins, rgba } from "@similarweb/styles";
import styled from "styled-components";

export const StyledCrmIntegratedDescription = styled.p`
    ${mixins.setFontVariant("body2", rgba(colorsPalettes.midnight["500"], 0.54))}
    line-height: 20px;
    margin: 0 0 12px;
    max-width: 275px;
`;
